// @flow
import Properties from "../../../Properties";
import {
  getInit,
  postInit,
  graphQLInit,
  deleteInit
} from "../../global/types/constants";
import type { DispatchType } from "../../global/types/redux";
import { apiFailCallbackHandle } from "../../account/containers/ErrosDisplay";
import {
  CompanyFacebaseNode,
  UserNode,
  UserAdminNode
} from "../../account/types/GraphQlNodes";
import { buildAdminUserNodefromGraphQlNode } from "../../account/components/companies/CompileCompanytoJson";
import {
  ADMIN_REMOVE_USER_FROM_COMPANY,
  ADMIN_REMOVE_USER_FROM_FACEBASE,
  ADMIN_GET_ALL_USERS,
  ADMIN_REMOVE_USER_ITEM,
  ADMIN_GET_ALL_GROUPS,
  ADMIN_APPEND_USER_DATA,
  ADMIN_GET_COMPANY_FACEBASE,
  ADMIN_UPDATE_USER_LIST,
  REMOVE_COMPANY_USER,
  ADMIN_GET_GROUP_USERS
} from "../../global/actions/actionNames";

const root = Properties.api_root;

export const fetctAllUsers = (callBack?: Function): * => (
  dispatch: DispatchType
): * => {
  return fetch(`${root}/auth/v2/users?detailed=true`, getInit)
    .then(response => response.json())
    .then(json => {
      dispatch({ type: ADMIN_GET_ALL_USERS, users: json.users });
      callBack && callBack(json.users);
    });
};

export const fetctGroupUsers = (groupName: string, callBack?: Function): * => (
  dispatch: DispatchType
): * => {
  return fetch(`${root}/auth/v2/users?group_name=${groupName}`, getInit)
    .then(response => response.json())
    .then(json => {
      dispatch({ type: ADMIN_GET_GROUP_USERS, users: json.users });
      callBack && callBack(json.users);
    });
};

export function deleteUser(
  userId: string,
  source: string,
  parentId: string,
  doneBack: Function,
  failBack: Function
): * {
  return (dispatch: any) => {
    fetch(root + "/auth/v2/users/" + userId, deleteInit())
      .then(response => response.json())
      .then(function(json) {
        if (json.errors) {
          failBack && failBack(apiFailCallbackHandle(json.errors));
        } else {
          if (source === "adminCompany") {
            dispatch({
              type: ADMIN_REMOVE_USER_FROM_COMPANY,
              userId: userId,
              companyId: parentId
            });
          } else if (source === "adminFacebase") {
            dispatch({
              type: ADMIN_REMOVE_USER_FROM_FACEBASE,
              userId: userId,
              facebaseId: parentId
            });
          } else if (source === "adminUser") {
            dispatch({ type: ADMIN_REMOVE_USER_ITEM, userId: userId });
          } else if (source === "company") {
            dispatch({ type: REMOVE_COMPANY_USER, userId: userId });
          }
          doneBack && doneBack();
        }
      })
      .catch(err => {
        failBack && failBack(apiFailCallbackHandle(err.message));
      });
  };
}

export const fetctAllPrincipals = (callBack?: Function): * => (
  dispatch: DispatchType
): * => {
  return fetch(`${root}/auth/v2/groups`, getInit)
    .then(response => response.json())
    .then(json => {
      dispatch({ type: ADMIN_GET_ALL_GROUPS, groups: json.groups });
      callBack && callBack(json.groups);
    });
};

export function fetchUserPrincipals(
  userId: string,
  doneBack: Function,
  failBack: Function
): * {
  return (dispatch: any) => {
    fetch(root + "/auth/v2/users/" + userId + "/groups", getInit)
      .then(response => response.json())
      .then(function(json) {
        if (json.errors) {
          failBack && failBack(apiFailCallbackHandle(json.errors));
        } else {
          dispatch({
            type: ADMIN_APPEND_USER_DATA,
            userId: userId,
            field: "groups",
            data: json.groups
          });
          doneBack && doneBack(json.groups);
        }
      });
  };
}

export const fetchCompanyFacebases = (callback?: Function): * => (
  dispatch: DispatchType
): * => {
  const graphQl = `
  {
    allCompanies {
      ${CompanyFacebaseNode}
    }
  }
  `;
  return fetch(`${root}/api/v2/company/graphql`, graphQLInit(graphQl))
    .then(response => response.json())
    .then(json => {
      dispatch({
        type: ADMIN_GET_COMPANY_FACEBASE,
        companies: json.data.allCompanies
      });
      callback && callback(json.data.allCompanies);
    });
};

export const adminUpdateUser = (
  userUuid: string,
  facebaseId: string,
  firstName: string,
  lastName: string,
  companyId: string,
  email: string,
  groups: Array<string>,
  doneCallback: Function,
  failCallBack: Function
): * => (dispatch: DispatchType, getState: *): * => {
  const graphQl = `
    mutation {
      updateUser(
        userUuid: "${userUuid}",
        facebaseId: "${facebaseId}",
        firstName: "${firstName}",
        lastName: "${lastName}",
        companyId: "${companyId}",
        email: "${email}",
        userGroups: ${JSON.stringify(groups)}
      ){
        ok
        errors {
          field
          message
        }
        user {
          ${UserNode}
          ${UserAdminNode}
        }
      }
    }
    `;
  return fetch(`${root}/api/v2/company/graphql`, graphQLInit(graphQl))
    .then(response => response.json())
    .then(json => {
      if (json.errors) {
        failCallBack && failCallBack(apiFailCallbackHandle(json.errors));
      } else {
        const result = json.data.updateUser;
        if (result.ok) {
          const jsonUser = { ...result.user };
          const users = getState().v3admin.user.users;
          let user = buildAdminUserNodefromGraphQlNode(
            jsonUser,
            email,
            users[userUuid].user_status,
            groups
          );

          dispatch({ type: ADMIN_UPDATE_USER_LIST, user: user });
          doneCallback && doneCallback(user);
        } else {
          failCallBack && failCallBack(apiFailCallbackHandle(result.errors));
        }
      }
    })
    .catch(err => {
      failCallBack && failCallBack(apiFailCallbackHandle(err.message));
    });
};

export function resendRegistrationEmail(
  userId: string,
  doneBack: Function,
  failBack: Function
): * {
  return (dispatch: any) => {
    fetch(root + "/auth/v2/users/" + userId + "/resend_email", getInit)
      .then(response => response.json())
      .then(function(json) {
        if (json.errors) {
          failBack && failBack(apiFailCallbackHandle(json.errors));
        } else {
          doneBack && doneBack();
        }
      })
      .catch(err => {
        failBack && failBack(apiFailCallbackHandle(err.message));
      });
  };
}

export const fetchUserUsage = (
  userUuid: string,
  startDate: Date,
  endDate: Date,
  callBack?: Function
): * => (dispatch: DispatchType): * => {
  dispatch({
    type: ADMIN_APPEND_USER_DATA,
    userId: userUuid,
    field: "startDate",
    data: startDate
  });
  dispatch({
    type: ADMIN_APPEND_USER_DATA,
    userId: userUuid,
    field: "endDate",
    data: endDate
  });
  const startNode = startDate ? `start_date=${startDate}` : "";
  const endNode = endDate ? `end_date=${endDate}` : "";
  return fetch(
    `${root}/auth/v2/users/${userUuid}/usage?${startNode}&${endNode}`,
    getInit
  )
    .then(response => response.json())
    .then(json => {
      let data = groupUsageData(json);
      dispatch({
        type: ADMIN_APPEND_USER_DATA,
        userId: userUuid,
        field: "usage",
        data: data
      });
      callBack && callBack(data);
    });
};

function groupUsageData(usage: Array<*>): * {
  let ds = {};
  for (let i = 0; i < usage.length; i++) {
    let key = usage[i].endpoint_name + ":" + usage[i].methods;
    if (key in ds) {
      if (usage[i].status in ds[key]) {
        ds[key][usage[i].status] += 1;
      } else {
        ds[key][usage[i].status] = 1;
      }
    } else {
      ds[key] = { [usage[i].status]: 1 };
    }
  }

  return ds;
}
